const loader = document.querySelector('.loader') as HTMLElement;
window.addEventListener('load', function () {
    loader.remove()
    document.body.removeAttribute('class')
})

if (history.scrollRestoration) {
    history.scrollRestoration = 'manual';
} else {
    window.onbeforeunload = function () {
        window.scrollTo(0, 0);
    }
}

